import { render } from "./DisplayInfo.vue?vue&type=template&id=dc267b6c&scoped=true"
import script from "./DisplayInfo.vue?vue&type=script&lang=js"
export * from "./DisplayInfo.vue?vue&type=script&lang=js"

import "./DisplayInfo.vue?vue&type=style&index=0&id=dc267b6c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc267b6c"]])

export default __exports__